"use client";

import { Box, Flex, Separator, Text } from "@chakra-ui/react";

const size = "md";

export const CardTable = ({ label, items }) => {
  if (!(items && items[0])) {
    return null;
  }
  return (
    <Box mt={"6"} alignSelf={"flex-start"}>
      <Text textStyle={size} ml={"0.5rem"}>
        {label}
      </Text>
      <Flex
        flexDirection="column"
        gap={2}
        mt={2}
        borderWidth={1}
        borderRadius={10}
        pl={5}
        pr={5}
        pt={3}
        pb={3}
      >
        {items?.map((item) => {
          if (item.id === "total") {
            return (
              <Box key={item.id}>
                <Separator colorPalette={"textv2.brand"} pb={'0.5rem'}/>
                <Flex color={"textv2.brand"} width={"28rem"} gap={4}>
                  <Text width="40%" textStyle={size}>
                    {item.c1}
                  </Text>
                  <Text width="30%" textAlign={"right"} textStyle={size}>
                    {item.c2}
                  </Text>
                  <Text width="30%" textAlign={"right"} textStyle={size}>
                    {item.c3}
                  </Text>
                </Flex>
              </Box>
            );
          }
          return (
            <>
              {item?.id === "refund-amount" || item?.id === 'required-funds' ? (
                <Separator colorPalette={"textv2.brand"} />
              ) : null}
              <Flex key={item.id} width={"28rem"} gap={"0.5rem"}>
                <Text width="40%" textStyle={size}>
                  {item.c1}
                </Text>
                <Text width="30%" textAlign={"right"} textStyle={size}>
                  {item.c2}
                </Text>
                <Text width="30%" textAlign={"right"} textStyle={size}>
                  {item.c3}
                </Text>
              </Flex>
            </>
          );
        })}
      </Flex>
    </Box>
  );
};
